import { Component, effect, inject, Injector } from '@angular/core';
import { SoTabsBaseComponent } from '../../so-tabs-base.component';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';
import { VoiceSettingsService } from '@modules/configuration-ia/services/api/bot-ia/voice-settings/voice-settings.service';
import { BotIaService } from '@modules/configuration-ia/services/api/bot-ia/bot-ia.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NoSaveDataAlertService } from '@core/services/no-save-data-alert/no-save-data-alert.service';
import { SharedStateKbdService } from '@modules/configuration-ia/services/signals/kbd/shared-state-kbd.service';
import { TokenService } from '@modules/configuration-ia/services/api/token.service';


@Component({
  selector: 'app-so-tabs-ia',
  templateUrl: './so-tabs-ia.component.html',
  styleUrl: '../../so-tabs-base.component.scss'
})
export class SoTabsIaComponent extends SoTabsBaseComponent {

  private injector = inject(Injector);
  public trunkBaseConfiguration = inject(TrunkBaseConfigurationService);
  public voiceSettingsService = inject(VoiceSettingsService);
  public botIaService = inject(BotIaService);
  public route = inject(Router);
  public activatedRoute = inject(ActivatedRoute);
  public tokenService = inject(TokenService);
  public noSaveDataAlertService = inject(NoSaveDataAlertService);
  public sharedStateKdbService = inject(SharedStateKbdService);

  public isUploading: boolean = true;
  public isUploadingTextFile: boolean = true;
  public isSavingData: boolean = false; // Se inicializa luego con signal
  private savedTabIndex: number | null = null;

  constructor() {
    super();
    this.getStateUploading();
  }

  ngAfterViewInit(): void {
    if (this.enableUnsavedDataCheck) {
      this.activateIsSavingEffect();
    }
  }

  private activateIsSavingEffect() {
    this.isSavingData = this.noSaveDataAlertService.$isSavingData;
    effect(() => {
      this.isSavingData = this.noSaveDataAlertService.$isSavingData;
      if (
        this.savedTabIndex != null &&
        !this.isSavingData &&
        this.noSaveDataAlertService.$activateAlert
      ) {
        this.activeTabIndex = this.savedTabIndex;
        this.voiceSettingsService.isSavingVoice = false;
        this.botIaService.isSavingPrompting = false;
        this.botIaService.isSavingPromptingSeekop = false;
        this.activeTabIndexChange.emit(this.activeTabIndex);
      }
    }, { injector: this.injector });
  }

  override setActiveTab(index: number): void {
    if (this.noSaveDataAlertService.$isSavingData && this.enableUnsavedDataCheck) {
      this.savedTabIndex = index;
      return;
    }
    super.setActiveTab(index);
  }

  override navigateToStep(route: string, index: number): void {
    const saving = this.noSaveDataAlertService.$isSavingData && this.enableUnsavedDataCheck;
    if (saving) {
      this.savedTabIndex = index;
    }
    this.route.navigate([route], {
      relativeTo: this.activatedRoute,
      queryParams: { token: this.tokenService.urlToken },
    }).then((navigated) => {
      if (navigated && !saving) {
        this.activeTabIndex = index;
        this.activeTabIndexChange.emit(this.activeTabIndex);
      }
    });
  }
  private getStateUploading() {
    this.sharedStateKdbService.isCompleted$.subscribe({
      next: (value) => {
        this.isUploading = value;
      }
    });
    this.sharedStateKdbService.textFileIsCompleted$.subscribe({
      next: (value) => {
        this.isUploadingTextFile = value;
      }
    });
  }

}
